<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Fuel Consumption</h6>
             </div>
             <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add</a>
         </div>


         <div class="card">
            <div class="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-4">
                
                <!-- Start Date -->
                <div class="w-full lg:w-auto">
                    <label for="startDate" class="block text-sm font-medium text-gray-700">From Date</label>
                    <input type="date" id="startDate" v-model="startDate" class="w-full p-2 border border-gray-300 rounded" />
                </div>
        
                <!-- End Date -->
                <div class="w-full lg:w-auto">
                    <label for="endDate" class="block text-sm font-medium text-gray-700">To Date</label>
                    <input type="date" id="endDate" v-model="endDate" class="w-full p-2 ml-3 mb-4 border border-gray-300 rounded" />
                </div>
        
                <!-- Filter Button -->
                <div>
                    <button  @click="getBasics" class="btn btn-primary-solid px-5 mt-5 ml-5 mb-4 lg:mt-0 cursor-pointer">Filter</button>
                </div>
            </div>
            </div>
        



                     <!-- Vendor Filter: Branch -->
                     <div class="w-full lg:w-auto ml-5" style="width: 250px;">
                         <label for="branch_name" class="block text-sm font-medium text-gray-700">Search Branch</label>
                         <select class="form-input w-full p-2 border border-gray-300 rounded" id="branch_name" ref="branch_name" v-model="sale.branch_name">
                             <option value=""></option>
                             <option value="All">ALL</option>
                             <option v-for="(item, index) in branchlist" :key="index" :value="item.id">{{ item.name }}</option>
                         </select>
                     </div>




         <!-- Start All Language List Table -->
         <div class="p-3 sm:p-4">
             <div class="overflow-x-auto scrollbar-table">
                 <table id="languageTable" class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                     <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                         <tr>
                            <th class="px-3.5 py-4">Consumption Date</th>
                             <th class="px-3.5 py-4">Branch Name</th>
                             <th class="px-3.5 py-4">Party Name</th>
                             <th class="px-3.5 py-4">Fuel Type</th>
                             <th class="px-3.5 py-4">Total<br>Fuel<br>Consumption</th>
                             <th class="px-3.5 py-4">Unit</th>
                             <th class="px-3.5 py-4">Vehicle No</th>
                             <th class="px-3.5 py-4">Action</th>
                         </tr>
                     </thead>
                     <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                         <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item ,index)  in catList" :key="item.id" > 
                            <td class="px-3.5 py-4">{{item.entrydate}}</td> 
                            <td class="px-3.5 py-4">{{item.branch_name}}</td>
                             <td class="px-3.5 py-4">{{item.party_name}}</td>
                             <td class="px-3.5 py-4">{{item.fuel_name}}</td>
                             <td class="px-3.5 py-4">{{item.consumptionltr}}</td>
                             <td class="px-3.5 py-4">{{item.unit}}</td> 
                             <td class="px-3.5 py-4">{{item.vehicle_name}}</td>
                            
                             <td class="px-3.5 py-4">
                                 <div class="flex items-center gap-1">


                                    <div class="flex items-center gap-1">
                                        <button 
                                            class="btn-icon btn-primary-icon-light size-7" 
                                            @click="singlefuel(item.partyid)" 
                                            title="Single Transaction List"
                                        >
                                            <i class="ri-exchange-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                        </button>
                                    </div>


<!--                                     
                                         <div class="flex items-center gap-1">
                                             <button 
                                                 class="btn-icon btn-primary-icon-light size-7" 
                                                 @click="singleparty(item.id)" 
                                                 title="Single Transaction List"
                                             >
                                                 <i class="ri-exchange-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                             </button>
                                         </div> -->
                                  
                                 
                                     <button 
                                         class="btn-icon btn-primary-icon-light size-7"  
                                         @click="editModal(item)"  
                                         title="Edit Item"
                                     >
                                         <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                                     </button>
                                 
                                     <button 
                                         class="btn-icon btn-danger-icon-light size-7" 
                                         @click="deleteModal(item.id)" 
                                         title="Delete Item"
                                     >
                                         <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                     </button>
                                 
                                 </div>
                                 
                             </td>
                         </tr>
                         
                     </tbody>

                     <tfoot>
                         <tr>
                           <td colspan="4" class="font-bold text-right">Total:</td>
                           <td class="font-bold">{{ totalfuelconsumed }}</td>
                         </tr>
                       </tfoot>


                 </table>
             </div>
         </div>
         <!-- End All Language List Table -->
     </div>
 </div>
 <!-- End Main Content -->

 <!-- Start Edit Modal -->
 <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-lg max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             
             <div class="p-4 md:p-5 overflow-y-auto">
           

                <div class="mt-7 grid grid-cols-2 gap-4">

                <div class="mt-7">
                    <label for="" class="form-label">Entry Date *</label>
                    <input type="date" id="barcode" v-model="cat.entrydate" placeholder="Type Here"
                        class="form-input" required autocomplete="off">
                    </div>
                
                 <div class="mt-7">
                             <label for="tagname" class="form-label">Branch Name*</label>
                             <select v-model="cat.branchid" class="form-input" @change="selectedBranchForFuel()">
                             <option v-for="(item, index) in branchlist" :key="index" :value="item.id">
                                 {{ item.name }}
                             </option>
                     </select>
                 </div>


                 

                         <div class="mt-7">
                             <label for="tagname" class="form-label">Party Name*</label>
                             <select v-model="cat.partyid" id="partylist_select2" class="form-input" @change="filterVehicleList">
                             <option v-for="(item, index) in partylist" :key="index" :value="item.id">
                                 {{ item.partyname }}
                             </option>
                     </select>
                 </div>



                             <div class="mt-7">
                                 <label for="tagname" class="form-label">Fuel Type*</label>
                                 <select v-model="cat.fueltypeid" class="form-input">
                                 <option v-for="(item, index) in fuelist" :key="index" :value="item.id">
                                     {{ item.name }}
                                 </option>
                         </select>
                     </div>



                     <div class="mt-7">
                     <label for="tagname" class="form-label">Fuel Consumption/Ltr *</label>
                     <input type="text" v-model="cat.consumptionltr" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                     <span>{{(currentStock>0)?'Current Stock '+currentStock:'NO STOCK'}}</span>
                     </div>

                     <div class="mt-7">
                         <label for="tagname" class="form-label">Unit*</label>
                        <select class="form-input" name="status" id="first_input" v-model="cat.unit">
                         <option value="">Choose Unit</option>
                         <option value="Ltr">Ltr</option>
                         <option value="ML">ML</option>
                        </select>
                     </div>


                     <div class="mt-7">
                         <label for="tagname" class="form-label">Vehicle Name/no*</label>
                         <select v-model="cat.vehicleid" class="form-input">
                         <option v-for="(item, index) in vehiclelist" :key="index" :value="item.id">
                             {{ item.vehicle }}
                         </option>
                 </select>
             </div>
            </div>

                  
             
                     <div class="flex justify-end mt-7">
                         <button @click="save_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                     </div> 
             </div>
         </div>
        
     </div>
 </div>
 <!-- End Edit Modal -->

 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-md max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5 text-center">
                 <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                 <div class="mt-5 text-center">
                     <h5 class="mb-1">Are you sure?</h5>
                     <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                     <div class="flex justify-center gap-2 mt-6">
                         <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                         <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'ProductCategory',
components: {
 
} ,
mounted(){
  //this.getBasics();
},
watch: {
    //   productsList () { // data used in the table
    //     this.$nextTick (() => { // wait until data fully updated before re-render new DOM 
    //       $('.datatable').DataTable().draw();
    //     })
    //   },
  },
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId:0,
     startDate:new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0],
     endDate: today,
     catList:[],
     partylist:[],
     vehiclelist:[],
     fuelist:[],
     branchlist:[],
     original_catList:[],
     all_vehiclelist:[],
     all_partylist:[],
     partyList:[],
     all_fuelist:[],
     dueamt:0,
     currentStock:0,
     sale: {
     branch_name: null,
  }, 
     cat:{branchid:'',fueltypeid:'',partyid:'',vehicleid:'',consumptionltr:'',unit:'',entrydate:this.todayDate(),status:''},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 }, 

 computed: {

            totalfuelconsumed() {
            return Array.isArray(this.catList)
            ? this.catList.reduce(
                (total, item) => total + (parseFloat(item.consumptionltr) || 0),
                0
                )
            : 0;
            },

},
   



methods:{
    selectedBranchForFuel(){
         
        var tmpSelectedBranch = this.branchlist.find(item => item.id === event.target.value);
        if(tmpSelectedBranch)
        this.currentStock=tmpSelectedBranch.stock;


        var selected_branchid=event.target.value;
         
        //  this.partylist = this. all_partylist.filter(item => {
            
        //      return item.branchid === selected_branchid; 
            
        //  });

            //  alert(event.target.value);
            var selected_branchid=event.target.value;
         
         this.vehiclelist = this.all_vehiclelist.filter(item => {
            
            return item.branchid === selected_branchid; 
            
         });


    },
   

  

 closeModal(){
     
         $("#editModal").addClass('hidden');
         $("#deleteModal").addClass('hidden');
     this.isAdd=0;
     this.isEdit=0;
     this.isDelete=0;
     this.deleteId=0;
 },
 addModal(){
     this.cat={branchid:'',fueltypeid:'',partyid:'',vehicleid:'',consumptionltr:'',unit:'Ltr',entrydate:this.todayDate(),status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
         $("#partylist_select2").val(copy.partyid).trigger('change');
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 todayDate() {
    const dateObj = new Date();
    let month = dateObj.getMonth() + 1;
    let day = dateObj.getDate();
    const currentDate = dateObj.getFullYear() + "-" + 
        (month < 10 ? "0" + month : month) + "-" + 
        (day < 10 ? "0" + day : day);
    return currentDate;
},


 deleteModal(id){
     this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getfuelconsumption',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
                self.destroyTable();
                 self.catList=response.data.fuelconsumptionlist;
                  self.original_catList=self.catList;
                 self.branchlist=response.data.branchList;
                 self.partylist=response.data.partyList;
                 self.all_partylist=response.data.partyList;
                 self.vehiclelist=response.data.vehicleList;
                 self.all_vehiclelist=response.data.vehicleList;
                 self.fuelist=response.data.fuelList;
                 self.all_fuelist=response.data.fuelList;
                 
                 // self.employees=response.data.userDetails;
                 // self.partyList=response.data.partylist;
             }).then(()=>{

                     self.refreshDatatble();
                  $("#partylist_select2").select2({
                                                     width: '80%',
                                                     dropdownAutoWidth : true,
                                                     placeholder:"Search Branch Here..."
                  }).on('change', function (event) {
                      self.cat.partyid=event.target.value;
                  });

                 $("#branch_name").select2({
                                     width: '80%',
                                     dropdownAutoWidth : true,
                                     placeholder:"Search Branch Here...",
                                 "language": {
                                             "noResults": function(){
                                                 return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                             }
                                         },
                                             escapeMarkup: function (markup) {
                                                 return markup;
                                             }
                                 }).on('change', function (event) {
                                   //  alert(event.target.value);
                                 //         self.sale.branchid=event.target.value; 
                                        self.destroyTable();
                                       //  self.catList.slice(0); 
                                         if(event.target.value>0) {
                                             self.catList=self.original_catList.filter(item =>item.branchid === event.target.value);
                                            
                                         }else{
                                              self.catList=self.original_catList;
                                         }    
                                         self.refreshDatatble();
                                      
                                         
                                     });

  
                });
  },
    refreshDatatble() {
        this.$nextTick(() => {
              $('#languageTable').DataTable( {
                dom: 'Bfrtip',
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );
        } );
         },
destroyTable(){
                if ($.fn.dataTable.isDataTable('#languageTable')) {
                        $('#languageTable').DataTable().destroy();
                    }  
},
//   async getBasicFilteredData(branchid) {
//        var self=this;
//          axios.post('getfuelconsumption',{branchid,branchid}).then(function (response) {
//                  self.catList=response.data.fuelconsumptionlist;
//                  self.branchlist=response.data.branchList;
//                  self.partylist=response.data.partyList;
//                  self.vehiclelist=response.data.vehicleList;
//                  self.fuelist=response.data.fuelList;
//                  // self.employees=response.data.userDetails;
//                  // self.original_catList=response.data.allparty;
//                  // self.partyList=response.data.partylist;
//              }).then(()=>{




//                  $("#branch_name").select2({
//                                      width: '80%',
//                                      dropdownAutoWidth : true,
//                                      placeholder:"Search Branch Here...",
//                                  "language": {
//                                              "noResults": function(){
//                                                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
//                                              }
//                                          },
//                                              escapeMarkup: function (markup) {
//                                                  return markup;
//                                              }
//                                  }).on('change', function (event) {
//                                          self.getBasicFilteredData(event.target.value); 
//                                          $('.languageTable').DataTable().destroy();                
                                         
//                                      });


//                  $('#languageTable').DataTable();
//                 });
//   },





  save_category() {
             var self = this; 
            if(self.cat.branchid=='' || self.cat.fueltypeid=='' ||self.cat.partyid=='')
                self.$swal("Please Enter Required Fields");
            else if(self.currentStock<=0)
                self.$swal("Sorry Stock Not Available");
            else{
             axios.post('savefuelconsumption', self.cat)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                   //  self.catList=response.data.cats;
                     self.employees=response.data.userDetails;
                     self.cat={name:'',status:'Active'};
                     self.getBasics();
                     self.closeModal();

                     //self.$swal(msg);
                     // if (isSuccess == 1) {
                     //     self.closeModal();
                     // }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
            }
               
         },
         delete_category() {
             var self = this; 
             axios.post('deletefuelconsumption', {deleteId:this.deleteId})
                 .then(response => {
                    // self.catList=response.data.fuelstocklist;
                     self.getBasics();
                     //self.catList=response.data.cats;
                     self.employees=response.data.userDetails; 
                      self.closeModal(); 
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         singlefuel(id) {
         window.open('/singlefuelreport?q=' + id,'_blank');
     },




}
}
</script>
